export var getDetailsRowCheckStyles = function () { return ({
    check: [
        {
            opacity: 1,
        },
    ],
}); };
//# sourceMappingURL=DetailsRowCheck.styles.js.map